import { appConfigStore } from 'Models/AppConfigStore';
import { getMeasurementValueFromId } from 'Util/_HumanWritten/MeasurementUtils';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';

export const useIsTrailerSpaceExceeded = (trailerSpaceAvailable: number, wizardData: BookingWizardData) => {
	const { tabSelected, innerWizardData } = wizardData;

	if (innerWizardData.type !== 'vehicle') {
		return false;
	}

	if (!appConfigStore.trailersEnabled) {
		return false;
	}

	if (tabSelected !== 'vehicle' || !innerWizardData.trailerCheckboxSelected) {
		return false;
	}

	const spaceToReserve = getMeasurementValueFromId(innerWizardData.trailerLengthId, true);

	return spaceToReserve > trailerSpaceAvailable;
};
